'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { label: 'Home', href: '/homepage' },
  { label: 'About', href: '/about' },
  { label: 'Impact & Programs', href: '/impact' },
  { label: 'Farms For Thought', href: '/farms-for-thought' },
  { label: 'Initiatives', href: '/initiatives' }];


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-background/90 backdrop-blur-[10px] shadow-brand-sm' :
      'bg-background'} ${
      className}`}>

      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 md:px-6 lg:px-8">
          <Link
            href="/homepage"
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity duration-300">

            <AppImage
              src="/assets/images/Untitled_design_1_-1770318847119.png"
              alt="Food For Thought Foundation Logo"
              width={400}
              height={100}
              className={`flex-shrink-0 object-contain transition-all duration-300 ${
                isScrolled ? 'brightness-0 invert' : ''
              }`} />
          </Link>

          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((item) =>
            <Link
              key={item.href}
              href={item.href}
              className={`px-4 py-2 text-sm font-body font-medium hover:bg-surface rounded-lg transition-all duration-300 ${
                isScrolled ? 'text-white hover:text-white/80' : 'text-black hover:text-brand-primary'
              }`}>

                {item.label}
              </Link>
            )}
          </nav>

          <div className="flex items-center space-x-3">
            <Link
              href="https://forms.gle/JAnAQKxV7VuoBwnGA"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:inline-flex items-center px-6 py-2.5 bg-brand-primary text-brand-primary-foreground font-header font-semibold text-sm rounded-lg hover:bg-brand-primary/90 hover:shadow-brand-md hover:-translate-y-1 transition-all duration-300">

              Get Involved
            </Link>

            <button
              onClick={toggleMobileMenu}
              className={`lg:hidden p-2 hover:bg-surface rounded-lg transition-all duration-300 ${
                isScrolled ? 'text-white hover:text-white/80' : 'text-text-secondary hover:text-brand-primary'
              }`}
              aria-label="Toggle mobile menu">

              <Icon
                name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
                size={24} />

            </button>
          </div>
        </div>

        {isMobileMenuOpen &&
        <div className="lg:hidden border-t border-border bg-background animate-slide-in-right">
            <nav className="px-4 py-4 space-y-1">
              {navLinks.map((item) =>
            <Link
              key={item.href}
              href={item.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-base font-body font-medium text-text-secondary hover:text-brand-primary hover:bg-surface rounded-lg transition-all duration-300">

                  {item.label}
                </Link>
            )}
              <Link
              href="https://forms.gle/JAnAQKxV7VuoBwnGA"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-base font-header font-semibold text-brand-primary-foreground bg-brand-primary hover:bg-brand-primary/90 rounded-lg text-center transition-all duration-300 mt-4">

                Get Involved
              </Link>
            </nav>
          </div>
        }
      </div>
    </header>);

};

export default Header;